import { Component, Input } from '@angular/core';
import { NavListItem, UserAccess } from '../navigation.component';
import { Router } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';
import { Subscription } from 'rxjs';
import { CustomerAccountDialogService } from '../../dialogs/customer-account-dialog/customer-account-dialog-service';
import { User } from 'anchor-shared/lib/model/entity/user';
import { DialogsService } from '../../../../core/services/dialog.service';

@Component({
  selector: 'app-main-navigation',
  templateUrl: './main-navigation.component.html',
})
export class MainNavigationComponent {
  @Input() route: string;
  @Input() user: User;
  @Input() navLogo;
  @Input() userAccess: UserAccess;
  @Input() navProfileItems: NavListItem[];
  @Input() isMobile: boolean;

  subs: Subscription[] = [];

  navItems: NavListItem[] = [
    {
      label: 'Contact',
      route: '/contact-anchor',
      customClass: 'hover-primary',
      section: 'main',
      icon: 'email',
      condition: () => this.showHomeNav(),
    },
    {
      label: 'Become an Anchor Captain',
      route: '/become-a-captain',
      customClass: 'hover-primary',
      section: 'main',
      icon: 'support_agent',
      condition: () => this.showHomeNav(),
    },
    {
      label: 'List Your Boat',
      route: '/list-my-boat',
      customClass: 'border border-2 border-primary rounded-2 p-2 hover-primary',
      section: 'main',
      icon: 'directions_boat',
      condition: () => this.showHomeNav(),
      unactivatable: true,
    },
    {
      label: 'Log out',
      condition: () => this.userAccess.isLoggedIn && this.showHomeNav(),
      action: () => this.logoutClick(),
      customClass: 'hover-primary',
      unactivatable: true,
    },
    {
      label: 'Sign Up',
      condition: () => !this.userAccess.isLoggedIn,
      action: () => this.openSignUpModal(),
      customClass: 'hover-primary',
      section: 'main',
      icon: 'person_add',
      unactivatable: true,
    },
    {
      label: 'Login',
      condition: () => !this.userAccess.isLoggedIn,
      action: () => {}, // force modal to close after click
      route: '/login',
      customClass: 'fw-bold mat-secondary',
      section: 'control',
      icon: 'login',
      unactivatable: true,
    },
  ];

  constructor(
    private customerAccountDialogService: CustomerAccountDialogService,
    private authService: AuthService,
    private router: Router,
    private dialogsService: DialogsService,
  ) {}

  openSignUpModal() {
    this.customerAccountDialogService
      .open(null, null)
      .subscribe((authSuccessful) => {
        if (authSuccessful) {
          this.router.navigate(['customer/charters']);
        } else {
          console.error('auth failed');
        }
      });
  }

  logoutClick(): void {
    const sub = this.authService.logout().subscribe(
      (data) => {
        this.router.navigate(['login']);
      },
      (error) => {
        console.log('logout failed');
      },
    );
    this.subs.push(sub);
  }

  expandNavList() {
    const navDialogSub = this.dialogsService
      .expandableNavListDialog([...this.navItems, ...this.navProfileItems])
      .subscribe();
    this.subs.push(navDialogSub);
  }

  showHomeNav() {
    const allowedPaths = [
      '/',
      '/login',
      '/become-a-captain',
      '/list-my-boat',
      '/contact-anchor',
    ];
    try {
      const url = new URL(this.route, 'https://anchorrides.com');
      return allowedPaths.includes(url.pathname);
    } catch {
      return false;
    }
  }
}
